<template>
  <div
    class="d-flex flex-column"
    style="flex: auto; overflow-y:auto;"
    data-cy="especialidade-container"
  >
    <div class="d-flex flex-row" data-cy="especialidade-header-row">
      <back-button data-cy="especialidade-back-button"></back-button>
      <div class="d-flex flex-column mb-4" data-cy="especialidade-header-info">
        <h4
          v-if="$route.fullPath.includes('exame')"
          class="text-primary font-weight-bold"
          data-cy="especialidade-title-procedimento"
        >
          Procedimento
        </h4>
        <h4
          v-else
          class="text-primary font-weight-bold"
          data-cy="especialidade-title-especialidade"
        >
          Especialidade
        </h4>
        <small class="font-weight-bold" data-cy="especialidade-subtitle">
          Busque ou selecione um{{
            $route.fullPath.includes("exame")
              ? " procedimento"
              : "a especialidade"
          }}
          abaixo
        </small>
      </div>
    </div>

    <search-filter
      :placeholder="
        `Buscar ${
          $route.fullPath.includes('exame') ? 'procedimento' : 'especialidade'
        }...`
      "
      data-cy="especialidade-search-filter"
    ></search-filter>

    <div
      class="d-flex flex-column"
      style="color: orange;"
      data-cy="especialidade-error-list"
    >
      <ul
        v-for="error in errors"
        :key="error"
        data-cy="especialidade-error-item"
      >
        <li>{{ error }}</li>
      </ul>
    </div>

    <loading-overlay
      v-if="isLoading"
      :message="loadingMessage"
      data-cy="especialidade-loading-overlay"
    />

    <form
      v-else
      @submit.prevent="checkForm"
      style="overflow-y: auto;"
      data-cy="especialidade-form"
    >
      <div
        class="text-primary text-uppercase py-3"
        data-cy="especialidade-list-wrapper"
      >
        <div
          :class="
            `custom-radio-wrapper mb-2 ${
              specialty_s && especialidade.id === specialty_s.id
                ? 'border-primary'
                : ''
            }`
          "
          v-for="especialidade in especialidades"
          :key="especialidade.id"
          :data-cy="`especialidade-item-${especialidade.id}`"
        >
          <div
            class="custom-control custom-radio"
            data-cy="especialidade-radio-wrapper"
          >
            <input
              type="radio"
              :id="'speciality-' + especialidade.id"
              class="custom-control-input"
              :value="especialidade"
              @change="submit(especialidade)"
              :checked="specialty_s && especialidade.id === specialty_s.id"
              @click="advance"
              :data-cy="`especialidade-radio-${especialidade.id}`"
            />
            <label
              class="custom-control-label"
              :for="'speciality-' + especialidade.id"
              :data-cy="`especialidade-label-${especialidade.id}`"
              >{{ especialidade.nome }}</label
            >
            <span
              class="help-block"
              v-if="especialidade.valor"
              :data-cy="`especialidade-valor-${especialidade.id}`"
            >
              - R$ {{ especialidade.valor.toFixed(2) }}</span
            >
            <b-card
              :id="'orientacoes-' + especialidade.id"
              title="Orientações gerais:"
              class="border-0"
              v-if="isProcedimento && especialidade.orientacoes"
              :data-cy="`especialidade-orientacoes-${especialidade.id}`"
            >
              <p
                class="orientacoes"
                :data-cy="`especialidade-orientacoes-texto-${especialidade.id}`"
              >
                {{ especialidade.orientacoes }}
              </p>
            </b-card>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import BackButton from "@/components/back-button.vue";
import SearchFilter from "@/components/filter.vue";
import LoadingOverlay from "@/components/loading-overlay.vue";
import { generateTo } from "@/core/routerHelper.js";
import { mapGetters } from "vuex";

export default {
  name: "especialidade",
  data() {
    return {
      errors: []
    };
  },
  components: {
    SearchFilter,
    BackButton,
    LoadingOverlay
  },
  methods: {
    advance() {
      if (this.specialty_s && this.specialty_s.id) {
        this.submit(this.specialty_s);
      }
    },
    checkForm() {
      this.errors = [];
      if (this.speciality_selected == null) {
        this.errors.push("Selecione uma especialidade para prosseguir");
      } else {
        return true;
      }
    },
    submit(specialty) {
      specialty.stepId = 2;
      this.$store.dispatch("load_selected", specialty);
      this.$store.dispatch("set_to", {
        name: generateTo(this.clinicSpecific ? 4 : 3, this.$route),
        params: { organizationId: this.$route.params.organizationId },
        query: {
          convenio: this.$route.query.convenio,
          especialidade: specialty.id,
          ...(this.clinicSpecific
            ? { clinica: this.$route.query.clinica, c: null }
            : {})
        }
      });

      this.$router.push(this.$store.getters.to);
    }
  },
  computed: {
    ...mapGetters("loading", ["isLoading"]),
    loadingMessage() {
      return `Carregando ${
        this.$route.fullPath.includes("exame")
          ? "procedimentos"
          : "especialidades"
      }...`;
    },
    especialidades() {
      return this.$store.getters.get_specialitys;
    },
    to() {
      return this.$store.getters.to;
    },
    specialty_s() {
      return this.$store.getters.get_selected[1];
    },
    clinicSpecific() {
      return this.$store.getters.clinicSpecific;
    },
    isBackNav() {
      return this.$store.state.Config.goBack;
    },
    isProcedimento() {
      return this.$router.currentRoute.fullPath.includes("procedimento");
    }
  },
  async mounted() {
    let payload = {
      params: {
        organizationId: this.$route.params.organizationId
      },
      url: this.$route.fullPath.includes("exame")
        ? `${this.$serverHost}v2/agendamentos/procedimentos`
        : `${this.$serverHost}agendamentos/especialidades`
    };

    await this.$store.dispatch("load_speciality", payload);

    if (this.especialidades.length === 1 && !this.isBackNav) {
      this.submit(this.especialidades[0]);
    }

    this.$store.dispatch("setGoBack", false);
    this.$store.dispatch("set_actual", this.$route.fullPath);

    this.$store.dispatch("set_from", {
      name: generateTo(1, this.$route),
      params: { organizationId: this.$route.params.organizationId },
      query: {
        ...(this.clinicSpecific
          ? { clinica: this.$route.query.clinica, c: null }
          : {})
      }
    });

    if (this.specialty_s.nome) {
      if (this.$store.getters.clinicSpecific) {
        this.$store.dispatch("set_to", {
          name: generateTo(4, this.$route),
          params: { organizationId: this.$route.params.organizationId },
          query: {
            convenio: this.$route.query.convenio,
            clinica: this.$route.query.clinica,
            especialidade: this.specialty_s.id
          }
        });
      } else {
        this.$store.dispatch("set_to", {
          name: generateTo(3, this.$route),
          params: { organizationId: this.$route.params.organizationId },
          query: {
            convenio: this.$route.query.convenio,
            especialidade: this.specialty_s.id
          }
        });
      }
    } else {
      this.$store.dispatch("set_to", "");
    }
  }
};
</script>
<style>
.card-title {
  font-size: medium;
  font-weight: bold;
}
.orientacoes {
  font-size: small;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 4.5em;
}

.orientacoes:hover {
  max-height: 100%;
}
</style>
